import TabelaMembrosSemPg from './components/tabela'

export default function RelatorioPg() {
  return (
    <TabelaMembrosSemPg />
  )
}
